'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const LiquidationsTableError = () => {
  return <ErrorDataUnavailable minHeight="478px" />
}

export default memo(LiquidationsTableError)
